import activitiesTypes from "./activities.types";
import axios from "axios";
import Socket from "socket.io-client";

let url;
if (process.env.VUE_APP_NODE_ENV == "production") {
  url = `${process.env.VUE_APP_API_LIVE_URI}/activities`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/activities`;
}

const io = Socket(url);
export default {
  fetchTiersActivities({ commit }) {
    const ls = JSON.parse(localStorage.getItem("user"));
    commit(activitiesTypes.FETCH_TIER_ACTIVITIES_REQUEST);
    io.emit("fetch activities", {
      manager_email: ls.profile.email,
      type: "tier"
    });
    io.on("activities", function(data) {
      commit(activitiesTypes.FETCH_TIER_ACTIVITIES_SUCCESS, {
        data: { tierActivities: data }
      });
    });
    io.on("fetch action error", err => {
      return commit(activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED, {
        error: err.message
      });
    });
    /*
    axios
      .get(`${url}/all?email=${ls.profile.email}&type=tier`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(res => {
        //Route to a payment successful page
        commit(activitiesTypes.FETCH_TIER_ACTIVITIES_SUCCESS, {
          data: { tierActivities: res.data.activities }
        });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED, {
            error: "Network error"
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED, { error });
      });
      */
  },
  fetchActionsActivities({ commit }) {
    const ls = JSON.parse(localStorage.getItem("user"));
    commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_REQUEST);
    io.emit("fetch activities", {
      manager_email: ls.profile.email,
      type: "action"
    });
    io.on("activities", function(data) {
      commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_SUCCESS, {
        data: { actionActivities: data }
      });
    });
    io.on("fetch action error", err => {
      return commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED, {
        error: err.message
      });
    });
    /*
    axios
      .get(`${url}/all?email=${ls.profile.email}&type=action`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ls.accessToken}`
        }
      })
      .then(res => {
        //Route to a payment successful page
        commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_SUCCESS, {
          data: { actionActivities: res.data.activities }
        });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED, {
            error: "Network error"
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED, { error });
      });
      */
  }
};
